export default {
  addToFavorites: 'Добавить в избранные',
  any: 'Любой',
  and: 'и',
  adorable: 'Восхитительно',
  celebrate: 'Праздновать',
  clap: 'Хлопать',
  dislike: 'Не нравится',
  fire: 'Огонь',
  artists: 'Artists',
  allocate: 'Распределить',
  assignAsCreator: 'Назначить постановщиком',
  attach: 'Прикрепить',
  apply: 'Применить',
  backtrace: 'Отладочная информация',
  cancel: 'Отмена',
  caution: 'Осторожно!',
  clear: 'Очистить',
  clearSelection: 'Очистить выбор',
  client: 'Клиент',
  clientDebt: 'Долг клиента',
  clients: 'Клиенты',
  companyTabs: 'Вкладки компании',
  close: 'Закрыть',
  confirm: 'Подтвердить',
  copyLink: 'Копировать ссылку',
  create: 'Создать',
  debt: 'Долг',
  delete: 'Удалить',
  delete_filter: 'Удалить фильтр',
  description: 'Описание',
  download: 'Скачать',
  downloadTaskResult: 'Скачать результаты задачи',
  errorMessage: 'Сообщение об ошибке',
  enterMessageId: 'Укажите ID сообщения',
  enterMessageIds: 'Укажите IDs сообщения',
  expand_view: 'Открыть просмотр',
  favorite: 'Избранное',
  unfavorite: 'Не избранное',
  filterFavorite: 'Фильтровать избранные',
  flagged: 'Отмеченное',
  from: 'От',
  generate: 'Сгенерировать',
  hide: 'Скрыть',
  hideList: 'Скрыть список',
  homepage: 'Вернуться на главную',
  info: 'Информация',
  invisibleForClient: 'Спрятано от клиенов',
  invisibleForWorker: 'Спрятано от сотрудников',
  invite_user: 'Пригласить пользователя',
  laughing: 'Смеюсь',
  like: 'Нравится',
  love: 'Любовь',
  log_out: 'Выйти',
  login_page: 'Перейти на страницу авторизации',
  mad: 'Злой',
  members: 'Участники',
  membersGenitiveLowerCase: 'участников',
  model: 'Модель',
  new: 'Новый',
  newVersionAvailable: 'Доступна новая версия!',
  no: 'Нет',
  noResultsYet: 'Нет результатов',
  noSearchResults: 'Ничего не найдено',
  of: 'из',
  open_in_new_tab: 'Открыть в новой вкладке',
  or: 'Или',
  pinned: 'Закрепленное',
  postMessage: 'Отправить сообщение',
  processing: 'Обработка...',
  remove: 'Удалить',
  removeFromFavorites: 'Убрать из избранных',
  rename: 'Переименовать',
  reset_password: 'Сбросить пароль',
  sad: 'Грустный',
  save: 'Сохранить',
  saveFilter: 'Сохранить фильтр',
  savedFilters: 'Сохранённые фильтры',
  search: 'Поиск',
  searchByName: 'Поиск по названию',
  searchResults: 'Результаты поиска',
  search_user_by_name: 'Поиск по имени пользователя',
  searching: 'Поиск...',
  loadingMore: 'Загрузка...',
  secondsGenitive: 'секунд',
  select: 'Выбрать',
  selectToAddToTheProject: 'Выбрать, чтобы добавить в проект',
  selected: 'Выбрано',
  sendInstructions: 'Отправить инструкции',
  sendToAllTasks: 'Отправить во все задачи',
  setDueDate: 'Установить дату завершения',
  settings: 'Настройки',
  showList: 'Показать список',
  showMore: 'Показать еще',
  showing: 'Показано',
  sign_out: 'Выйти',
  sku: 'SKU',
  stop: 'Стоп',
  submit: 'Отправить',
  surprised: 'Удивленный',
  to: 'До',
  total: 'Итог',
  updateImageVersions: 'Обновить версии изображения',
  updateNow: 'Обновить сейчас',
  viewAll: 'Посмотреть все',
  viewAllMembers: 'Посмотреть всех участников',
  viewProfile: 'Просмотреть профиль',
  visibleForClient: 'Видимо для клиента',
  workers: 'Сотрудники',
  yes: 'Да',
  system: 'Системная',
  colorSchemeDark: 'Тёмная',
  colorSchemeLight: 'Светлая',
  colorScheme: 'Цветовая схема',
  terrified: 'Испуганный',
  timer: {
    days: 'дней',
    hours: 'часов',
    minutes: 'минут',
    seconds: 'секунд'
  },
  show_n_selected_items: {
    show: 'Показать',
    selected_items: 'выбранных элементов'
  }
};
